module.exports = __webpack_public_path__ + "static/media/title3.7d558872.png";